/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const fr_terms_of_use_page_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Découvrez les conditions d'utilisation du site de Juslin Komenan : responsabilités, propriété intellectuelle et limites de responsabilité. Infos clés ici.`)
};

const en_terms_of_use_page_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore the terms of use for Juslin Komenan’s website: user responsibilities, intellectual property, and liability limitations. Essential information here.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const terms_of_use_page_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.terms_of_use_page_description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("terms_of_use_page_description", locale)
	if (locale === "fr") return fr_terms_of_use_page_description(inputs)
	return en_terms_of_use_page_description(inputs)
};